import { Link } from 'react-router-dom'
import React, { useState } from 'react'
import { FormLabel, Hyperlink, Notification, TextInput } from '@offerzen/pinata-shame'
import BareBonesNavbar from '../../components/BareBonesNavbar'
import Container from '../../components/Container'

const HomeScene = () => {
  const [slug, setSlug] = useState('offerzen')

  return (
    <>
      <BareBonesNavbar />
      <Container>
        <h1>Company Experience a.k.a. Ox 🐂</h1>

        <form>
          <FormLabel label="Company slug" htmlFor="slug" />
          <TextInput value={slug} onChange={newValue => setSlug(newValue)} id="slug" />
        </form>

        <ul>
          <li>
            <Hyperlink label="Dashboard" href={`/company/${slug}/dashboard`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Positions" href={`/company/${slug}/positions`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Candidates" href={`/company/${slug}/candidates`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Favourites" href={`/company/${slug}/shortlist`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Messages" href={`/company/${slug}/interview_requests`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Analytics" href={`/company/${slug}/analytics`} as={Link} />
          </li>
          <li>
            <Hyperlink label="Integrations" href={`/company/${slug}/integration_partners`} as={Link} />
          </li>
        </ul>

        <p>Pre-live views:</p>
        <ul>
          <li>
            <Hyperlink label="Welcome" href={`/company/${slug}/welcome`} as={Link} />
          </li>
        </ul>
        <Notification theme="info">This page is only visible in non-production environments.</Notification>
      </Container>
    </>
  )
}

export default HomeScene
